import { supabase } from '../lib/supabase'
import {
  APP_SETTING_BLACK_BOX_100,
  APP_SETTING_CLEAR_BOX_100,
  computeGarbageBagsCost,
  parseBoxCostSetting,
} from '../lib/garbageBags'

export interface GarbageBagBoxCosts {
  clearBoxOf100: number
  blackBoxOf100: number
}

export async function fetchGarbageBagBoxCosts(): Promise<GarbageBagBoxCosts> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('key, value')
    .in('key', [APP_SETTING_CLEAR_BOX_100, APP_SETTING_BLACK_BOX_100])
  if (error) throw error
  const map: Record<string, unknown> = {}
  for (const row of data || []) map[row.key] = row.value
  return {
    clearBoxOf100: parseBoxCostSetting(map[APP_SETTING_CLEAR_BOX_100]),
    blackBoxOf100: parseBoxCostSetting(map[APP_SETTING_BLACK_BOX_100]),
  }
}

/** Snapshot bag COGS at completion using current tenant box rates. */
export async function snapshotGarbageBagsCost(
  clearBags: number,
  blackBags: number
): Promise<number> {
  const rates = await fetchGarbageBagBoxCosts()
  return computeGarbageBagsCost(
    clearBags,
    blackBags,
    rates.clearBoxOf100,
    rates.blackBoxOf100
  )
}
